export enum StatusCheque {
  NaSecretaria = "NaSecretaria",
  Recolhido = "Recolhido",
  Depositado = "Depositado",
  Compensado = "Compensado",
  DevolvidoNoBanco = "DevolvidoNoBanco",
  DevolvidoNaSecretaria = "DevolvidoNaSecretaria",
  TrocadoOutroPagamento = "TrocadoOutroPagamento",
  SolicitadoNaSecretaria = "SolicitadoNaSecretaria",
}

export const StatusChequeLabel: Record<string, string> = {
  [StatusCheque.NaSecretaria]: "Na secretaria",
  [StatusCheque.Recolhido]: "Recolhido",
  [StatusCheque.Depositado]: "Depositado",
  [StatusCheque.Compensado]: "Compensado",
  [StatusCheque.DevolvidoNoBanco]: "Devolvido - no banco",
  [StatusCheque.DevolvidoNaSecretaria]: "Devolvido - na secretaria",
  [StatusCheque.TrocadoOutroPagamento]: "Trocado - outro pagamento",
  [StatusCheque.SolicitadoNaSecretaria]: "Solicitado - na secretaria",
};

export const StatusChequeCor: Record<string, string> = {
  [StatusCheque.NaSecretaria]: "default",
  [StatusCheque.Recolhido]: "blue",
  [StatusCheque.Depositado]: "geekblue",
  [StatusCheque.Compensado]: "green",
  [StatusCheque.DevolvidoNoBanco]: "red",
  [StatusCheque.DevolvidoNaSecretaria]: "volcano",
  [StatusCheque.TrocadoOutroPagamento]: "purple",
  [StatusCheque.SolicitadoNaSecretaria]: "gold",
};

export type ChequeType = {
  id: number;
  alunoId: number;
  matricula?: number;
  nomeAluno?: string;
  nomeDonoCheque?: string;
  banco?: string;
  agencia?: string;
  conta?: string;
  numero?: string;
  parcela?: number;
  valor?: number;
  dataVencimento?: string;
  dataRecolhimento?: string;
  dataDeposito?: string;
  status?: StatusCheque;
  statusLabel?: string;
  motivoDevolucao?: string;
  unidadeId: number;
  unidadeNome?: string;
  trocaPagamentoNome?: string;
  trocaCv?: number;
  trocaDataTransacao?: string;
  quantidadeContatos: number;
};

export type ChequeHistoricoType = {
  id: number;
  statusAnterior?: string;
  statusNovo?: string;
  observacao?: string;
  usuarioNome?: string;
  dataRegistro: string;
};

export type ChequeContatoType = {
  id: number;
  dataContato: string;
  acordo?: string;
  prazo?: string;
  nomeContato?: string;
  usuarioNome?: string;
  dataRegistro: string;
};

export type ChequeDetalheType = ChequeType & {
  historicos: ChequeHistoricoType[];
  contatos: ChequeContatoType[];
};
